import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from 'firebase/app';




// eslint-disable-next-line
import * as analytics from 'firebase/analytics';

Vue.config.productionTip = false




const getRuntimeConfig = async () => {
  let windowLocation =  window.location.toString();

  let configLocation = '/cfg/runtimeConfig.json';
  if( windowLocation.indexOf("192.168") > -1 || windowLocation.indexOf("localhost") > -1){
    configLocation = '/cfg/devConfig.json';
  }
  const runtimeConfig = await fetch(configLocation);
  return await runtimeConfig.json()
}
getRuntimeConfig().then(function(json) {
  


  var firebaseConfig = {
    apiKey: json.googleApiKey,
    authDomain: json.googleAuthDomain,
    databaseURL: "",
    projectId: json.googleProjectId,
    storageBucket: "",
    messagingSenderId: "",
    appId:  json.googleAppId,
    measurementId:  json.googleMeasurementId
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();


  firebase.auth().onAuthStateChanged(user => {
    store.dispatch("changeUser", user);
  });

 Vue.mixin({
  data() {
    return {
      // Distribute runtime configs into every Vue component
      GLOBAL_CONFIG: json
    }
  },
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')



});